import React from 'react';
import {
  PromoCard,
  SearchHeaderRow,
  SearchTitle,
  Subtitle,
  CTAButton,
} from './styles';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Typography } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { AdsClickOutlined } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const iconWrap = (bg) => ({
  width: 32,
  height: 32,
  borderRadius: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 1,
  backgroundColor: bg,
});

const card = (bg) => ({
  p: 2,
  borderRadius: 2,
border:'1px solid #ededed',
  textAlign: 'left',
});

const SearchPromoWidget = ({
  href = '/search',
  note = 'Browse over 5,000 NMRA registered medicines.',
}) => {
  return (
    <PromoCard>
      <SearchHeaderRow>
        <Box sx={{
      background: 'linear-gradient(-45deg, #4f46e5, #2563eb)',
      width: 48,
      height: 48,
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
            <SearchIcon style={{ fontSize: 38, color: 'white', width: 48,
      height: 48, padding:'5px'}} />
        </Box>
        <div>
          <SearchTitle>Search Medicines</SearchTitle>
          <Subtitle>Search over 5000 NMRA approved medicines to find alternative brands, side effects, and detailed information.</Subtitle>
        </div>
      </SearchHeaderRow>

      <Box sx={{ display: 'flex', flexDirection:'column', flexWrap: 'wrap', gap: '12px', justifyContent: 'center', mt: 1, mb:1 }}>
    {/* Brand Names */}
    <Box sx={card('#ECFDF3')}>
        <Box style={{display:'flex', flexDirection:'row', gap:'12px', alignItems:'center'}}>
      <Box sx={iconWrap('#D1FAE5')}>
        <CategoryIcon sx={{ fontSize: 18, color: '#059669' }} />
      </Box>
      <Typography variant="subtitle1" fontWeight={600} sx={{color: '#059669' }}>
        Brand Names
      </Typography>
      </Box>
      <Typography variant="body2" style={{color:'#333', fontWeight:'500'}}>
        Search commercial brands like “Tylenol” or “Advil”
      </Typography>
    </Box>

    {/* Generic Names */}
    <Box sx={card('#F0F7FF')}>
        <Box style={{display:'flex', flexDirection:'row', gap:'12px', alignItems:'center'}}>
      <Box sx={iconWrap('#DBEAFE')}>
        <ShowChartIcon sx={{ fontSize: 18, color: '#2563EB' }} />
      </Box>
      <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#2563EB' }}>
        Generic Names
      </Typography>
      </Box>
      <Typography variant="body2" style={{color:'#333', fontWeight:'500'}}>
        Find by active ingredients like “Acetaminophen”
      </Typography>
    </Box>

    {/* Alternatives */}
    <Box sx={card('#FFF7F9')}>
        <Box style={{display:'flex', flexDirection:'row', gap:'12px', alignItems:'center'}}>
      <Box sx={iconWrap('#ffeaee')}>
        <AdsClickOutlined sx={{ fontSize: 18, color: 'error.light' }} />
      </Box>
      <Typography variant="subtitle1" fontWeight={600} sx={{color: 'error.light'}}>
        Side Effects
      </Typography>
      </Box>
      <Typography variant="body2" style={{color:'#333', fontWeight:'500'}}>
        View common side effects with one click.
      </Typography>
    </Box>
  </Box>

      <CTAButton component={RouterLink} to={href}>Search Now</CTAButton>
    </PromoCard>
  );
};

export default SearchPromoWidget;
